import { gql } from '@apollo/client';

const CASE_WITH_DOCUMENTS = `
  id
  documents {
    id
    name
    uploadedOn
    status
    expiryDate
    url
    type {
      id
      name
      endDate
      expiryDateRequired
      type
    }
    uploadedBy {
      id
      firstName
      lastName
    }
    file {
      id
      url
      name
    }
  }
`;

// Persist a single document against an existing case (document modal Save).
export const UPSERT_CASE_DOCUMENT = gql`
  mutation upsertCaseDocument($caseId: ID!, $input: UpsertCaseDocumentInput!) {
    case: upsertCaseDocument(caseId: $caseId, input: $input) {
      ${CASE_WITH_DOCUMENTS}
    }
  }
`;

// Delete a single document (case-level Cancel cleanup for rows added this session).
export const DELETE_CASE_DOCUMENT = gql`
  mutation deleteCaseDocument($id: ID!) {
    case: deleteCaseDocument(id: $id) {
      ${CASE_WITH_DOCUMENTS}
    }
  }
`;
